<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item> <i class="el-icon-s-data"></i> 数据字典 </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-button
                    type="primary"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
                    v-if="perData.allow_dele == 1"
                    >批量删除</el-button
                >
                <el-input v-model="name" placeholder="搜索页面，名称" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                <el-button style="float:right" type="primary" icon="el-icon-plus" @click="handleAdd" v-if="perData.allow_add == 1"
                    >添加</el-button
                >
            </div>
            <el-table
                :data="tableData"
                border
                stripe
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                <el-table-column prop="type_no" label="系统编号" align="center"></el-table-column>
                <el-table-column prop="type_name" label="系统名称" align="center"></el-table-column>
                <el-table-column prop="code" label="页面编号" align="center"></el-table-column>
                <el-table-column prop="chinese" label="页面名称" align="center"></el-table-column>
                <el-table-column prop="status" label="是否显示" align="center" v-if="nowName == 'administrator'">
                    <template slot-scope="scope">
                        <el-tag effect="dark" v-if="scope.row.status == 1" type="success">是</el-tag>
                        <el-tag effect="dark" v-else type="danger">否</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="250" align="center" v-if="perData.allow_edit == 1 || perData.allow_dele == 1">
                    <template slot-scope="scope">
                        <el-button type="primary" plain icon="el-icon-edit" @click="handleEdit(scope)" v-if="perData.allow_edit == 1"
                            >{{ $t('common.edit') }}</el-button
                        >
                        <el-button
                            type="danger"
                            plain
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope)"
                            v-if="perData.allow_dele == 1"
                            >{{ $t('common.delete') }}</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="pageIndex"
                    :page-sizes="[5, 10, 20, 50, 100]"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>
        <!-- 添加类别 -->
        <el-dialog title="添加" :visible.sync="addData.isshow" width="40%">
            <el-form label-width="120px">
                <el-form-item label="系统编号">
                    <el-input v-model="addData.data.type_no"></el-input>
                </el-form-item>
                <el-form-item label="系统名称">
                    <el-input v-model="addData.data.type_name"></el-input>
                </el-form-item>
                <el-form-item label="父 级">
                    <label slot="label">父&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;级</label>
                    <el-select v-model="addData.data.father_id" placeholder="请选择">
                        <el-option label="无" value=""></el-option>
                        <el-option v-for="(item, index) in pullData" :key="index" :label="item.chinese" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="图 标">
                    <label slot="label">图&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;标</label>
                    <el-input v-model="addData.data.echinese"></el-input>
                </el-form-item>
                <el-form-item label="页面编号">
                    <el-input v-model="addData.data.code"></el-input>
                </el-form-item>
                <el-form-item label="页面名称">
                    <el-input v-model="addData.data.chinese"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <div style="display:flex">
                        <el-input type="number" v-model="addData.data.sort_seq" style="padding-right:10px"></el-input>
                        <el-button type="primary" plain @click="getSeq('add')">获取排序</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="是否显示" v-if="nowName == 'administrator'">
                    <el-switch v-model="addData.data.status" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addData.isshow = false">取 消</el-button>
                <el-button type="primary" @click="saveAdd">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 编辑弹出框 -->
        <el-dialog :title="$t('common.edit')" :visible.sync="editData.isshow" width="40%">
            <el-form label-width="120px">
                <el-form-item label="系统编号">
                    <el-input v-model="editData.data.type_no"></el-input>
                </el-form-item>
                <el-form-item label="系统名称">
                    <el-input v-model="editData.data.type_name"></el-input>
                </el-form-item>
                <el-form-item label="父 级">
                    <label slot="label">父&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;级</label>
                    <el-select v-model="editData.data.father_id" placeholder="请选择">
                        <el-option label="无" value=""></el-option>
                        <el-option v-for="(item, index) in pullData" :key="index" :label="item.chinese" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="图 标">
                    <label slot="label">图&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;标</label>
                    <el-input v-model="editData.data.echinese"></el-input>
                </el-form-item>
                <el-form-item label="页面编号">
                    <el-input v-model="editData.data.code"></el-input>
                </el-form-item>
                <el-form-item label="页面名称">
                    <el-input v-model="editData.data.chinese"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <div style="display:flex">
                        <el-input type="number" v-model="editData.data.sort_seq" style="padding-right:10px"></el-input>
                        <el-button type="primary" plain @click="getSeq('edit')">获取排序</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="是否显示" v-if="nowName == 'administrator'">
                    <el-switch v-model="editData.data.status" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editData.isshow = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { fetchData } from '../../api/index';
import {
    apiGetSeq,
    apiDictionaryList,
    apiDictionaryDetail,
    apiaddDictionary,
    apimodifyDictionary,
    apidelDictionary,
    apiPullDictionary,
    apiCurrentPermisson,
    apiGetinfo
} from '@/request/api';
export default {
    name: 'basetable',
    data() {
        return {
            name: '',
            pageIndex: 1,
            pageSize: 10,
            tableData: [],
            perData: '',
            pullData: [],
            pageTotal: 0,
            typeNo: '',
            selectList: [],
            editData: { isshow: false, scope: null, index: 0, data: {} },
            addData: { isshow: false, scope: null, index: 0, data: {} },
            nowName: ''
        };
    },
    created() {
        this.getData();
        this.getPull();
        this.getPermission();
        this.getUserInfo();
    },
    activated() {
        this.getData();
        this.getPull();
        this.getPermission();
    },
    methods: {
        // 获取排序
        getSeq(type) {
            var obj = null;
            if (type == 'add') obj = this.addData;
            else obj = this.editData;

            apiGetSeq({
                type_no: obj.data.type_no || '',
                father_id: obj.data.father_id || ''
            }).then(res => {
                if (res.code == 2000) this.$set(obj.data, 'sort_seq', res.data.sort_seq);
                else this.$message.error(res.data.info);
            });
        },
        // 获取列表信息
        getData() {
            this.$load.show();
            apiDictionaryList({
                page: this.pageIndex,
                page_size: this.pageSize,
                keyword: this.name
            }).then(res => {
                this.$load.close();
                if (res.code == 2000) {
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.page_total;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getUserInfo() {
            apiGetinfo({}).then(res => {
                if (res.code == 2000) {
                    this.nowName = res.data.login_staff;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获取下拉框信息
        getPull() {
            apiPullDictionary({}).then(res => {
                if (res.code == 2000) {
                    this.pullData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '16'
            }).then(res => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.pageIndex = 1;
            this.getData();
        },
        //添加----------------------------------------------------------------------------------------------------
        handleAdd() {
            this.addData.isshow = true;
            this.addData.data = { sort_seq: 999 };
        },
        saveAdd() {
            let data = this.addData.data;
            apiaddDictionary(data).then(res => {
                if (res.code == 2000) {
                    this.$message({ message: '添加成功', type: 'success' });
                    this.addData.isshow = false;
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 删除操作----------------------------------------------------------------------------------------------------
        handleDelete(scope) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    apidelDictionary({
                        id: scope.row.id
                    }).then(res => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 多选删除操作----------------------------------------------------------------------------------------------------
        handleSelectionChange(user) {
            let arr = [];
            let arr1 = [];
            user.forEach(function(item, index, array) {
                arr.push(item.id);
            });
            this.selectList = arr;
        },
        delAllSelection() {
            if (this.selectList.length <= 0) {
                this.$message({ message: '请先选择需要操作的对象', type: 'error' });
                return;
            }
            this.$confirm('此操作将批量删除, 是否继续?', '批量删除提示', {
                confirmButtonText: this.$t('common.confirm') ,
                cancelButtonText: this.$t('common.cancel') ,
                type: 'warning'
            })
                .then(() => {
                    apidelDictionary({
                        id: this.selectList.join(',')
                    }).then(res => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {
                    // this.$message({ type: 'info',  message: '已取消删除' });
                });
        },
        // 编辑操作----------------------------------------------------------------------------------------------------
        handleEdit(scope) {
            const { row, $index } = scope;
            this.editData.isshow = true;
            this.editData.data = {
                id: row.id,
                type_no: row.type_no,
                type_name: row.type_name,
                code: row.code,
                chinese: row.chinese,
                echinese: row.echinese,
                father_id: row.father_id,
                status: row.status == 1 ? true : false,
                sort_seq: row.sort_seq || 999
            };
            this.editData.row = row;
            this.editData.index = $index;
        },
        // 保存编辑
        saveEdit() {
            let data = this.editData.data;
            apimodifyDictionary(data).then(res => {
                if (res.code == 2000) {
                    this.$message({ message: '修改成功', type: 'success' });
                    this.editData.isshow = false;
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        pageSizeChange(val) {
            //
            this.pageSize = val;
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
.el-table thead {
    color: #000;
    font-weight: bold;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}
.el-table th {
    background: #ecf5ff !important;
}
</style>
